// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { ApplicationAccess_abstract } from './../abstract/SagaBase/ApplicationAccess_abstract';
export class ApplicationAccess extends ApplicationAccess_abstract {}
